module.exports = __webpack_public_path__ + "media/img/frontend_application/banner_emerge_venuerific_2022-300d8bb31a196ecd0af9673824fe23f1.png";